import { ICustomViewTableDropDownOptions, ICustomViewTableOptions } from "csi/middleware/customView/options/CustomViewOptions";
import { ComponentItem } from "designSystem/types/component-item-types";

export enum TimelineRangeType {
	RANGE_PAST  = "1",
	RANGE_PRESENT = "2",
	RANGE_FUTURE = "3",
}

export enum TimelineWeeksType {
	ONE = 1,
	THREE = 3,
	FIVE = 5,
	SEVEN = 7,
	NINE = 9,
	ELEVEN = 11,
	THIRTEEN = 13,
}

export const TimelineWeeksOptions = [
	{ id: TimelineWeeksType.ONE, name: "1", value: 1 },
	{ id: TimelineWeeksType.THREE, name: "3", value: 3 },
	{ id: TimelineWeeksType.FIVE, name: "5", value: 5 },
	{ id: TimelineWeeksType.SEVEN, name: "7", value: 7 },
	{ id: TimelineWeeksType.NINE, name: "9", value: 9 },
	{ id: TimelineWeeksType.ELEVEN, name: "11", value: 11 },
	{ id: TimelineWeeksType.THIRTEEN, name: "13", value: 13 },
];

export interface ICustomViewTimelineOptions extends ICustomViewTableOptions {
	/** indicates how timeline week range is determined relative to present date */
	timelineRange?: TimelineRangeType;

	/** number of weeks to display in timeline */
	timelineWeeks?: TimelineWeeksType;
}

export interface ICustomViewTimelineDropDownOptions extends ICustomViewTableDropDownOptions {
	/** week range options */
	readonly timelineRangeOptions: ComponentItem[];

	/** weeks to display options */
	readonly timelineWeeksOptions: ComponentItem[];
}